<template>
    <div class="row">
        <div class="col">
            <button v-facebook-sign-in-button="facebookAppId" class="btn btn-info btn-facebook btn-lg btn-block" :disabled="disabled" @click="error = false">
                <img src="../../assets/images/fb-icon.svg" alt="facebook" class="float-left">
                Login with Facebook
            </button>
            <button v-google-sign-in-button="googleClientId" class="btn btn-google btn-lg btn-block is-invalid" :disabled="disabled" @click="error = false">
                <img src="../../assets/images/google-icon.svg" alt="google" class="float-left ml-1">
                Login with Google
            </button>
            <div class="invalid-feedback text-center pt-2" v-if="error">
                Problem with social authentication
            </div>
        </div>
    </div>
</template>

<script>
import GoogleSignInButton from '../../directives/google-signin-button-directive';
import FacebookSignInButton from '../../directives/facebook-signin-button-directive';

export default {
        name: "SocialButtons",
        directives: {GoogleSignInButton, FacebookSignInButton},
        props: {
            disabled: Boolean
        },
        data: function () {
            return {
                googleClientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
                facebookAppId: process.env.VUE_APP_FB_APP_ID,
                error: false
            }
        },
        methods: {
            onFacebookConnected: function (authResponse) {
                this.$emit('auth', {
                    provider: 'facebook',
                    token: authResponse.accessToken
                });
            },
            onFacebookError: function () {
                this.error = true;
            },
            OnGoogleAuthSuccess(accessToken) {
                this.$emit('auth', {
                    provider: 'google',
                    token: accessToken
                });
            },
            OnGoogleAuthFail() {
                this.error = true;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/base";

    .btn-facebook {
        background-color: #3178EA;

        &:hover {
            background-color: darken(#3178EA, 10%);
        }
    }

    .btn-google {
        color: $gray-600;
        background: $white;
        border: 0.5px solid $gray-500;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    }
</style>
